import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";
import { incrementUsage } from "@/hooks/useUsageLimits";

export function useCreateRecording() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isCreating, setIsCreating] = useState(false);

  const createRecording = async (roomId?: string | null) => {
    if (!user) {
      toast.error("Please sign in to start recording");
      return null;
    }

    setIsCreating(true);

    try {
      const timestamp = new Date().toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });

      const { data, error } = await supabase
        .from("content")
        .insert({
          user_id: user.id,
          type: "recording",
          title: `Recording - ${timestamp}`,
          visibility: "private",
          room_id: roomId || null,
        })
        .select("id")
        .single();

      if (error) throw error;

      // Track usage for content uploads
      await incrementUsage("content_uploads");

      // Navigate to the content page
      navigate(`/content/${data.id}`);
      return data.id;
    } catch (error) {
      console.error("Error creating recording:", error);
      toast.error("Failed to start recording");
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return { createRecording, isCreating };
}
